import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'components.Organizations.Switch.title',
    defaultMessage: 'Choose an organisation view',
  },
  choose: {
    id: 'components.Organizations.Switch.choose',
    defaultMessage: 'Choose',
  },
  active: {
    id: 'components.Organizations.Switch.active',
    defaultMessage: 'Active',
  },
  edit: {
    id: 'components.Organizations.Switch.edit',
    defaultMessage: 'Edit',
  },
  searchPlaceholder: {
    id: 'component.Organizations.Switch.searchPlaceholder',
    defaultMessage: 'Search',
  },
  testingOrganizationsToggle: {
    id: 'component.Organizations.Switch.testingOrganizationsToggle',
    defaultMessage: 'Hide testing organizations',
  },
  totalResults: {
    id: 'component.Organizations.Switch.totalResults',
    defaultMessage: 'Total: {count}',
  },
})
